import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Table, Button, Tag, Typography } from 'antd'
import moment from 'moment'
import numeral from 'numeral'

import { getLogs } from '../../modules/priceSchedule'

const { Text } = Typography

const LOG_STATUS_COLOR = {
  SUCCESS: 'green',
  FAILED: 'red',
  BLOCKED: 'orange',
  TIMEOUT: 'default'
}

const formatDateTime = (value) => {
  if (!value) return '-'
  return moment(value).format('YYYY-MM-DD HH:mm:ss')
}

const PriceSchedules = () => {
  const dispatch = useDispatch()

  const { logs, isLogLoading } = useSelector(
    (state) => ({
      logs: state.priceSchedule.logs,
      isLogLoading: state.priceSchedule.isLogLoading
    }),
    []
  )

  useEffect(() => {
    dispatch(getLogs(50))
  }, [dispatch])

  const onReload = () => {
    dispatch(getLogs(50))
  }

  const logColumns = [
    {
      title: 'เวลา',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 180,
      render: formatDateTime
    },
    {
      title: 'ชื่อสินค้า',
      key: 'price_name',
      render: (text, record) => {
        const name = record.price_name || record.name
        if (!name) return '-'
        return (
          <div>
            <div>{name}</div>
            {record.price_name_en && (
              <Text type="secondary" style={{ fontSize: 12 }}>
                {record.price_name_en}
              </Text>
            )}
          </div>
        )
      }
    },
    {
      title: 'สถานะ',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (status) => {
        const upper = String(status || '').toUpperCase()
        return <Tag color={LOG_STATUS_COLOR[upper]}>{upper || 'UNKNOWN'}</Tag>
      }
    },
    {
      title: 'ข้อความ',
      dataIndex: 'message',
      key: 'message',
      render: (msg) => <Text style={{ fontSize: 12 }}>{msg || '-'}</Text>
    },
    {
      title: 'Response',
      dataIndex: 'response_size',
      key: 'response_size',
      width: 110,
      align: 'right',
      render: (size) =>
        size == null ? '-' : `${numeral(size).format('0,0')} B`
    },
    {
      title: 'เวลา (ms)',
      dataIndex: 'duration_ms',
      key: 'duration_ms',
      width: 100,
      align: 'right',
      render: (ms) => (ms == null ? '-' : numeral(ms).format('0,0'))
    }
  ]

  return (
    <div>
      <div
        style={{
          marginBottom: 16,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
        <Typography.Title level={3} style={{ margin: 0 }}>
          Log การดึงราคา
        </Typography.Title>
        <Button icon="reload" onClick={onReload} loading={isLogLoading}>
          Reload
        </Button>
      </div>

      <Card title="Log ล่าสุด (50 รายการ)">
        <Table
          loading={isLogLoading}
          scroll={{ x: 1100 }}
          rowKey={(record, index) => record.id || index}
          dataSource={logs}
          columns={logColumns}
          pagination={{ pageSize: 20 }}
          size="small"
        />
      </Card>
    </div>
  )
}

export default PriceSchedules
